module.exports = __webpack_public_path__ + "img/download-log.0e2c288e.svg";